import styled from '@emotion/styled';
import { tokens, Link } from '@hotjar/hotsauce';

export const StyledLink = styled(Link)`
  ${tokens.text('caption')}
`;

export const TermsOfServiceLink = styled(Link)`
  ${tokens.text('body2')}
`;

export const SignInText = styled.div`
  margin-top: ${tokens.spacer.x6};
  ${tokens.text('caption')};
`;

export const EmailErrorText = styled.span`
  & a {
    color: ${tokens.color.text_danger};
    text-decoration: underline;
  }
`;
